import React, { SyntheticEvent } from 'react';
import { Label, Slider, Input, InputWrapper, Description } from './styles';

export const Toggle = ({
  label,
  isChecked,
  onToggle,
  labelAlignment = 'left',
  className,
}: ToggleProps) => (
  <Label className={className}>
    {labelAlignment === 'left' && (
      <Description alignment={labelAlignment}>{label}</Description>
    )}
    <InputWrapper $isChecked={isChecked}>
      <Input type="checkbox" checked={isChecked} onChange={onToggle} />
      <Slider />
    </InputWrapper>
    {labelAlignment === 'right' && (
      <Description alignment={labelAlignment}>{label}</Description>
    )}
  </Label>
);

export interface ToggleProps {
  className?: string;
  label?: string;
  isChecked?: boolean;
  disabled?: boolean;
  labelAlignment?: 'left' | 'right';
  onToggle: (e: SyntheticEvent) => void;
}
